import { Reveal } from "./Reveal";
import { useT } from "../../i18n/locale-context";

/**
 * The same job in every trade: a lead emails in, OctoMail reads it and replies
 * in the owner's voice. Each card shows an inbound inquiry + the reply in that
 * vertical's own language. Replies never quote a price or commit to a date
 * (mirrors the live autopilot guardrail). Copy lives in the i18n dictionaries;
 * the dedicated /for pages are English-only static HTML for now.
 */
const ORDER = [
  { key: "dealerships", href: "/for/car-dealerships" },
  { key: "contractors", href: "/for/contractors" },
  { key: "dental", href: "/for/dentists" },
  { key: "auto", href: "/for/auto-repair" },
  { key: "rv", href: "/for/rv-dealers" },
  { key: "sales", href: "/for/sales-teams" },
] as const;

export function Industries() {
  const t = useT();
  const ind = t.landing.industries;
  return (
    <section
      id="industries"
      className="mx-auto max-w-6xl px-5 py-14 sm:px-8 sm:py-20"
    >
      <Reveal>
        <div className="text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.12em] text-brand-600">
            {ind.eyebrow}
          </p>
          <h2 className="font-display mt-3 text-3xl font-semibold sm:text-4xl">
            {ind.title}
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-lg text-slate-600">{ind.sub}</p>
        </div>
      </Reveal>
      <div className="mt-12 grid gap-5 sm:grid-cols-2">
        {ORDER.map(({ key, href }, i) => {
          const it = ind.items[key];
          return (
            <Reveal key={key} delay={i * 60} className="min-w-0">
              <div className="glass-card glass-lift h-full p-5">
                <p className="text-xs font-bold uppercase tracking-wider text-slate-900">
                  {it.label}
                </p>
                <div className="mt-3 space-y-2">
                  <div className="rounded-2xl rounded-bl-sm bg-slate-100 px-3.5 py-2.5">
                    <span className="block text-[10px] font-bold uppercase tracking-wider text-slate-600">
                      {ind.inbound}
                    </span>
                    <p className="mt-0.5 text-sm text-slate-700">{it.inbound}</p>
                  </div>
                  <div className="rounded-2xl rounded-br-sm border border-sky-100 bg-sky-50 px-3.5 py-2.5">
                    <span className="block text-[10px] font-bold uppercase tracking-wider text-brand-600">
                      {ind.inYourVoice}
                    </span>
                    <p className="mt-0.5 text-sm text-sky-900">{it.reply}</p>
                  </div>
                </div>
                {/* Full-page nav to the static marketing page, so crawlers and
                    users both land on the dedicated vertical page. */}
                <a
                  href={href}
                  className="mt-4 inline-block text-sm font-semibold text-brand-600 hover:text-brand-700"
                >
                  {ind.seeFor(it.linkText)}
                </a>
              </div>
            </Reveal>
          );
        })}
      </div>
    </section>
  );
}
